import consumer from "./consumer";

document.addEventListener("turbo:load", () => {
  const storeOrder = document.querySelector('.store-order');

  if (storeOrder) {
    const storeId = storeOrder.getAttribute('data-store-id');

    consumer.subscriptions.create(
      { channel: "OrderNotificationsChannel", store_id: storeId },
      {
        connected() {
        },

        disconnected() {
        },

        received(data) {
          if (data.type === 'order_ready') {
            const orderElement = document.getElementById(`order-${data.order_id}`);
            if (orderElement) {
              // Deshabilitar botón Listo → "Lista"
              const markReadyBtn = orderElement.querySelector('.mark-ready-btn');
              if (markReadyBtn) {
                markReadyBtn.disabled = true;
                markReadyBtn.classList.remove('btn-notify-online', 'btn-notify-presencial');
                markReadyBtn.classList.add('btn-secondary');
                markReadyBtn.innerHTML = '<i class="bi bi-check-circle me-1"></i>Lista';
              }

              // Ocultar barra Preparar
              const claimSection = orderElement.querySelector('.order-claim');
              if (claimSection) {
                claimSection.remove();
              }

              // Opacidad en la card
              orderElement.classList.add('order-notified');
            }
          }

          if (data.type === 'customer_notified') {
            const orderElement = document.getElementById(`order-${data.order_id}`);
            if (orderElement) {
              const notifyBtn = orderElement.querySelector('.notify-customer-btn');
              if (notifyBtn) {
                notifyBtn.disabled = true;
                notifyBtn.classList.remove('btn-outline-success');
                notifyBtn.classList.add('btn-outline-secondary');
                notifyBtn.innerHTML = '<i class="bi bi-check-circle me-1"></i>Notificación enviada';
              }
            }
          }
        }
      }
    );
  }
});
